import { BarChart3, CreditCard, TrendingUp, Wallet, type LucideIcon } from 'lucide-react';

import { Permission } from '../../../types/permissions';

import type { NavRailItem, NavSection } from './nav-tree.types';

const READ_SALES_REPORTS = [Permission.READ_SALES_REPORTS, Permission.READ_ALL];

/** An unbuilt Finance page, gated like Daily sales so a viewer who cannot open
 *  that is not shown a section of nothing but unbuilt pages. */
const financeSoon = (id: string, label: string, icon: LucideIcon): NavRailItem => ({
  id,
  label,
  icon,
  to: '/admin/finance',
  ready: false,
  requiresAnyOf: READ_SALES_REPORTS,
});

export const FINANCE_SECTION: NavSection = {
  kind: 'section',
  id: 'finance',
  label: 'Finance',
  icon: Wallet,
  ready: true,
  home: '/admin/finance/daily-sales',
  items: [
    {
      id: 'daily-sales',
      label: 'Daily sales',
      icon: BarChart3,
      to: '/admin/finance/daily-sales',
      requiresAnyOf: READ_SALES_REPORTS,
    },
    financeSoon('revenue', 'Revenue', TrendingUp),
    financeSoon('ar-ap', 'AR/AP aging', CreditCard),
  ],
};
